"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlobDownloadUrlService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var User_service_1 = require("../User.service");
var Http_service_1 = require("../http/Http.service");
var ApplicationApi_service_1 = require("../jsonServiceApi/ApplicationApi.service");
var JsonApi_service_1 = require("../jsonServiceApi/JsonApi.service");
var BlobDownloadUrlService = /** @class */ (function () {
    function BlobDownloadUrlService(jsonApiService, httpService, userService, applicationApiService) {
        this.jsonApiService = jsonApiService;
        this.httpService = httpService;
        this.userService = userService;
        this.applicationApiService = applicationApiService;
    }
    BlobDownloadUrlService.prototype.getBlobDownloadUrl = function (blobId, isWorkSpace, fileName) {
        var _this = this;
        if (fileName === void 0) { fileName = ''; }
        return this.jsonApiService.post('BlobDownloadUrlService', 'GetBlobDownloadUrl', fileName, {
            query: {
                blobId: blobId,
                personal: isWorkSpace ? '1' : undefined,
                clientType: this.userService.getLoginInfo().clientType,
            },
            retryCallback: function () { return _this.getBlobDownloadUrl(blobId, isWorkSpace, fileName); },
        });
    };
    BlobDownloadUrlService.prototype.authcookie = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, appInfo, authCookieApiUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accessToken = this.userService.getAccessToken();
                        return [4 /*yield*/, this.applicationApiService.getApplicationInfo()];
                    case 1:
                        appInfo = _a.sent();
                        authCookieApiUrl = appInfo.ServiceResult.System.SystemOptions.DownloadServiceAuthCookieApi;
                        if (window.Seismic.userBehaviourTrackTemp && window.Seismic.userBehaviourTrackTemp.log4authCookie) {
                            window.Seismic.userBehaviourTrackTemp.log4authCookie(accessToken, authCookieApiUrl);
                        }
                        if (accessToken) {
                            return [2 /*return*/, this.httpService.post(authCookieApiUrl, accessToken, {
                                    headers: {
                                        'Content-Type': 'text/plain',
                                    },
                                })];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BlobDownloadUrlService = __decorate([
        CommonService_decorator_1.CommonService('BlobDownloadUrlService', { replaceAngularService: 'blobdownloadService' }),
        __metadata("design:paramtypes", [JsonApi_service_1.JsonApiService,
            Http_service_1.HttpService,
            User_service_1.UserService,
            ApplicationApi_service_1.ApplicationApiService])
    ], BlobDownloadUrlService);
    return BlobDownloadUrlService;
}());
exports.BlobDownloadUrlService = BlobDownloadUrlService;
//# sourceMappingURL=BlobDownloadUrl.service.js.map